// extracted by mini-css-extract-plugin
export default {"footer":"Footer-module__footer--J6Lhr","title":"Footer-module__title--x_KMJ"};